module.exports = __webpack_public_path__ + "img/dish.f4cd121.png";